export default "__VITE_PUBLIC_ASSET__ca4eed74__"